import {
  IEditCustomerUserPayload,
  IGetCustomerUserList,
  ICustomerUserCreate,
  ICustomerUserDetails,
  ICustomerUserListSearch,
  ChangeCustomerUserPassword,
} from "../../types/customerUserInterface";
import { CustomerUserActionTypes, CustomerUserActions } from "../actionTypes/customerUserActionTypes";

export const createCustomerUser = (payload: ICustomerUserCreate): CustomerUserActionTypes => ({
  type: CustomerUserActions.CREATE_CUSTOMER_USER,
  payload,
});

export const getCustomerUserList = (payload: ICustomerUserListSearch): CustomerUserActionTypes => ({
  type: CustomerUserActions.GET_CUSTOMER_USER_LIST,
  payload,
});

export const setCustomerUserList = (customerUserList: Array<IGetCustomerUserList>): CustomerUserActionTypes => ({
  type: CustomerUserActions.SET_CUSTOMER_USER_LIST,
  payload: customerUserList,
});

export const setCustomerUserListPageCount = (payload:number): CustomerUserActionTypes => ({
  type: CustomerUserActions.SET_CUSTOMER_USER_LIST_PAGE_COUNT,
  payload
})

export const getCustomerUserDataById = (id: number | string): CustomerUserActionTypes => ({
  type: CustomerUserActions.GET_CUSTOMER_USER_DATA_BY_ID,
  payload: id,
});

export const setCustomerUserDataById = (payload: ICustomerUserDetails) => ({
  type: CustomerUserActions.SET_CUSTOMER_USER_DATA_BY_ID,
  payload,
});

export const editCustomerUser = (payload: IEditCustomerUserPayload) => ({
  type: CustomerUserActions.EDIT_CUSTOMER_USER_DATA_BY_ID,
  payload,
});

export const changeCustomerUserPassword = (payload: ChangeCustomerUserPassword) => ({
  type: CustomerUserActions.CHANGE_CUSTOMER_USER_PASSWORD,
  payload
})
